import React, { useState } from 'react';
import HomeConfigureButton, { HOME_CONFIGURE_BUTTON_TYPE } from '../HomeConfigureButton';
import styled from 'styled-components';
import Button from 'components/Button';
import Modal from 'components/Modal';
import Text from 'components/Text';
import LayoutButton from './LayoutButton';
import { HomeLayoutCode } from 'services/shop/constants';
import shopSelectors from 'services/shop/selectors';
import shopActions from 'services/shop/actions';
import { useAppDispatch } from 'store/hooks';

const HomeLayoutToggle = () => {
  const dispatch = useAppDispatch();
  const allSetting = shopSelectors.data.allSetting();
  const layoutHomeCode = allSetting?.layoutHomeCode;
  const [open, setVisible] = useState(false);
  const onOpen = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };
  const onChangeLayout = (code: HomeLayoutCode) => () => {
    dispatch(shopActions.changeHomeLayout(code));
    onClose();
  };
  return (
    <>
      <HomeConfigureButton onClick={onOpen} type={HOME_CONFIGURE_BUTTON_TYPE.HOME_LAYOUT} />
      <Modal
        v2
        visible={open}
        onClose={onClose}
        modalTitle='Home Layout'
        width={'auto'}
        containerPadding={1}
        noneBodyStyle
        hiddenOkButton
        hiddenHeader
      >
        <StyledModal>
          <Text mb={1} variant='H2'>LAYOUT</Text>
          <Divider />
          <Body>
            <LayoutButton code={HomeLayoutCode.LAYOUT_1} active={layoutHomeCode === HomeLayoutCode.LAYOUT_1} onClick={onChangeLayout(HomeLayoutCode.LAYOUT_1)} />
            <LayoutButton code={HomeLayoutCode.LAYOUT_2} active={layoutHomeCode === HomeLayoutCode.LAYOUT_2} onClick={onChangeLayout(HomeLayoutCode.LAYOUT_2)} />
            <LayoutButton code={HomeLayoutCode.LAYOUT_3} active={layoutHomeCode === HomeLayoutCode.LAYOUT_3} onClick={onChangeLayout(HomeLayoutCode.LAYOUT_3)} />
            <LayoutButton code={HomeLayoutCode.LAYOUT_4} active={layoutHomeCode === HomeLayoutCode.LAYOUT_4} onClick={onChangeLayout(HomeLayoutCode.LAYOUT_4)} />
          </Body>
        </StyledModal>
      </Modal>
    </>
  );
};

export default HomeLayoutToggle;

const StyledModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Divider = styled.div`
  width: 54.775px;
  height: 4px;
  background: #2D6772;
`;
const Body = styled.div`
  display: flex;
  padding: 24px 40px 40px 40px;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  background: #FFF;
`;
